import { DropdownItem } from 'components/Dropdown/types'
import useAppSetting from 'hooks/use-app-setting'
import useAppMutation from 'hooks/use-app-mutation'
import { updateLanguagePreferences } from 'services/user'
import { useMemo } from 'react'

const useLanguage = () => {
  const {
    key: { LANGUAGE_OPTIONS },
  } = useAppSetting()

  const updateLanguage = useAppMutation(['updateLanguage'], updateLanguagePreferences)

  const languageOptions: DropdownItem<string>[] = useMemo(
    () =>
      LANGUAGE_OPTIONS?.map((obj: { id: string; description: string }) => ({
        value: obj.id,
        label: obj.description,
      })) ?? [],
    [LANGUAGE_OPTIONS],
  )

  return { updateLanguage, languageOptions }
}

export default useLanguage
